import React, { ChangeEvent, useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import {
  BuscaParceiro,
  Categoria,
  InputSelect,
} from '~/components/NovosInputs';
import { useQuitacao } from '../../QuitacaoContext';
import FormActions from './FormActions';
import Lojas from './Lojas';

import moment from 'moment';
import {
  BtnGroupContainer,
  Container,
  ContainerDate,
  GroupTitle,
  InpuTypeDate,
  Title,
} from './styles';

export const FormFiltros: React.FC = () => {
  const {
    formFiltros,
    onChangeFormFiltros,
    finalizadoras,
    disabledFields,
    handleTipoCategoria,
    tipoCategoria,
    handleClearOptions,
    initData,
    formTela: {
      control,
      register,
      setValue,
      clearErrors,
      formState: { errors },
    },
    focusInput,
    setFocusInput,
    handleInitData,
  } = useQuitacao();

  const focusInputByName = (inputName: string) => {
    const inputElement = document.querySelector<HTMLInputElement>(
      `input[name="${inputName}"]`,
    );
    if (inputElement) {
      inputElement.click();
      inputElement.focus();
    }
  };

  useEffect(() => {
    if (focusInput) {
      focusInputByName('cod_pessoa');
    }
    setFocusInput(false);
  }, [focusInput, setFocusInput]);

  return (
    <Container>
      <Row>
        <Col sm={12} md={12}>
          <Lojas />
        </Col>

        <Col
          sm={12}
          md={5}
          style={{
            zIndex: 1,
          }}
        >
          <BuscaParceiro
            label="Parceiro *"
            placeholder="Selecione..."
            name="cod_pessoa"
            register={register}
            isError={!!errors.cod_pessoa}
            control={control}
            customOptions={{
              buscarPor: { cliente: true, loja: true, fornecedor: true },
            }}
            changeSelected={(selected: any) => {
              clearErrors('cod_pessoa');
              setValue('cod_pessoa', selected);
              onChangeFormFiltros({
                ...formFiltros,
                cod_pessoa: {
                  ...formFiltros.cod_pessoa,
                  value: selected,
                  isInvalid: selected.value === undefined,
                },
              });
              handleClearOptions();
            }}
            disabled={disabledFields}
          />
        </Col>

        <Col sm={12} md={3}>
          <InputSelect
            label="Finalizadora"
            name="cod_finalizadora"
            options={
              [
                {
                  label: 'Nenhuma',
                  value: undefined,
                },
                ...finalizadoras,
              ] as any[]
            }
            isDisabled={disabledFields}
            placeholder="Informe a Finalizadora"
            isError={formFiltros.cod_finalizadora.isInvalid}
            control={control}
            register={register}
            changeSelected={(value: any) => {
              setValue('cod_finalizadora', value);
              onChangeFormFiltros({
                ...formFiltros,
                cod_finalizadora: {
                  ...formFiltros.cod_finalizadora,
                  value,
                  isInvalid: value.value === undefined,
                },
              });
            }}
          />
        </Col>

        <Col sm={12} md={4}>
          <Categoria
            label="Categoria"
            ListaWidth="500px"
            placeholder="Selecione"
            tipoCategoria={tipoCategoria}
            register={register}
            disabled={disabledFields}
            isError={formFiltros.cod_categoria_quitacao.isInvalid}
            control={control}
            name="cod_categoria_quitacao"
            changeSelected={(value: any) => {
              onChangeFormFiltros({
                ...formFiltros,
                cod_categoria_quitacao: {
                  ...formFiltros.cod_categoria_quitacao,
                  value,
                  isInvalid: value.value === undefined,
                },
              });
              clearErrors('cod_categoria_quitacao');
              setValue('cod_categoria_quitacao', value);
            }}
          />
        </Col>
      </Row>

      <Row>
        {/* Grupo: Tipo */}
        <Col sm={12} md={2} className="containerTipo">
          <div role="group" aria-labelledby="tipo-label">
            <GroupTitle id="tipo-label">Tipo</GroupTitle>
            <BtnGroupContainer>
              <Button
                value="0"
                aria-pressed={formFiltros.tipo_conta.value === 0}
                className={
                  formFiltros.tipo_conta.value === 0
                    ? 'btn-group btn-group-active'
                    : 'btn-group'
                }
                disabled={disabledFields}
                onClick={() => {
                  handleTipoCategoria('Despesa');
                  setValue('flg_calc_juros', false);
                  setValue('cod_categoria_quitacao', {
                    label: '',
                    value: undefined,
                  });
                  onChangeFormFiltros({
                    ...formFiltros,
                    cod_categoria_quitacao: {
                      ...formFiltros.cod_categoria_quitacao,
                      value: { label: '', value: undefined },
                    },
                    tipo_conta: {
                      ...formFiltros.tipo_conta,
                      value: 0,
                    },
                  });
                }}
                type="button"
              >
                Pagar
              </Button>

              <Button
                value="1"
                aria-pressed={formFiltros.tipo_conta.value === 1}
                disabled={disabledFields}
                className={
                  formFiltros.tipo_conta.value === 1
                    ? 'btn-group btn-group-active'
                    : 'btn-group'
                }
                onClick={() => {
                  setValue('flg_calc_juros', false);
                  handleTipoCategoria('Receita');
                  setValue('cod_categoria_quitacao', {
                    label: '',
                    value: undefined,
                  });
                  onChangeFormFiltros({
                    ...formFiltros,
                    cod_categoria_quitacao: {
                      ...formFiltros.cod_categoria_quitacao,
                      value: { label: '', value: undefined },
                    },
                    tipo_conta: {
                      ...formFiltros.tipo_conta,
                      value: 1,
                    },
                  });
                }}
                type="button"
              >
                Receber
              </Button>
            </BtnGroupContainer>
          </div>
        </Col>

        {/* Grupo: Período */}
        <Col sm={12} md={2} className="containerPeriodo">
          <div role="group" aria-labelledby="periodo-label">
            <GroupTitle id="periodo-label">Período</GroupTitle>
            <BtnGroupContainer>
              <Button
                value="0"
                aria-pressed={formFiltros.tipo_periodo.value === 0}
                disabled={disabledFields}
                className={
                  formFiltros.tipo_periodo.value === 0
                    ? 'btn-group btn-group-active'
                    : 'btn-group'
                }
                onClick={() => {
                  onChangeFormFiltros({
                    ...formFiltros,
                    tipo_periodo: {
                      ...formFiltros.tipo_periodo,
                      value: 0,
                    },
                  });
                }}
                type="button"
              >
                Entrada
              </Button>

              <Button
                value="1"
                aria-pressed={formFiltros.tipo_periodo.value === 1}
                disabled={disabledFields}
                className={
                  formFiltros.tipo_periodo.value === 1
                    ? 'btn-group btn-group-active'
                    : 'btn-group'
                }
                onClick={() => {
                  onChangeFormFiltros({
                    ...formFiltros,
                    tipo_periodo: {
                      ...formFiltros.tipo_periodo,
                      value: 1,
                    },
                  });
                }}
                type="button"
              >
                Vencimento
              </Button>
            </BtnGroupContainer>
          </div>
        </Col>

        {/* Intervalo de datas */}
        <Col sm={12} md={2} className="colDataContainer">
          <Title>Intervalo</Title>
          <ContainerDate>
            <div
              className={`${
                formFiltros.dta_ini.isInvalid && initData ? 'alert-class' : ''
              }`}
            >
              <InpuTypeDate
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  const isInvalid = !moment(e.target.value).isValid();
                  onChangeFormFiltros({
                    ...formFiltros,
                    dta_ini: {
                      ...formFiltros.dta_ini,
                      value: e.target.value,
                      isInvalid,
                    },
                  });
                  if (e.target.value === '' && formFiltros.dta_fim.value === '')
                    handleInitData(false);
                }}
                value={formFiltros.dta_ini.value}
                type="date"
                disabled={disabledFields}
              />
            </div>
          </ContainerDate>
        </Col>

        <Col sm={12} md={2} className="colDataContainer">
          <ContainerDate>
            <div
              className={`${
                formFiltros.dta_fim.isInvalid && initData ? 'alert-class' : ''
              }`}
            >
              <InpuTypeDate
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  const isInvalid = !moment(e.target.value).isValid();
                  onChangeFormFiltros({
                    ...formFiltros,
                    dta_fim: {
                      ...formFiltros.dta_fim,
                      value: e.target.value,
                      isInvalid,
                    },
                  });
                  if (e.target.value === '' && formFiltros.dta_ini.value === '')
                    handleInitData(false);
                }}
                value={formFiltros.dta_fim.value}
                type="date"
                disabled={disabledFields}
              />
            </div>
          </ContainerDate>
        </Col>

        <Col
          sm={12}
          md={4}
          className="containerButtonAction"
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
          }}
        >
          <FormActions />
        </Col>
      </Row>
    </Container>
  );
};
